<template>
    <div class="container-fluid">
        <form id="FormPedidos" role="form" method="post" autocomplete="off" onSubmit="return false">
            <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                <template slot="header">
                    <th :class="StyleTh+' text-center'">#</th>
                    <th :class="StyleTh">Folio</th>
                    <th :class="StyleTh">Fecha</th>
                    <th :class="StyleTh">Cliente</th>
                    <th :class="StyleTh">Estatus</th>
                    <th :class="StyleTh">Acciones</th>
                </template>
                <template slot="body">
                    <tr v-for="(item,index) in Pedidos" :key="index">
                        <td class="text-center"><p :class="StyleTd">{{ index+1 }}</p></td>
                        <td><h6 :class="StylePr">{{ item.FolioFinal }}</h6></td>
                        <td><p :class="StyleTd">{{ item.Fecha }}</p></td>
                        <td><p :class="StyleTd">{{ item.Cliente }}</p></td>
                        <td><p :class="StyleTd">{{ item.Estatus }}</p></td>
                        <td v-if="BndMostrarBotones">
                            <button v-show="item.ShowButton" title="Agregar" @click="SeleccionarPedido(item)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                <i class="fas fa-plus text-primary"></i>
                            </button>
                        </td>
                    </tr>
                </template>
            </CList>
        </form>
    </div>
</template>
<script>
import Configs from '@/helpers/VarConfig.js';
export default{
    name:'ListPedidos',
    props:['poBtnSave','pPedidosSeleccionados','pIdCliente'],
    data(){
        return{
            ConfigModal:{
                ShowLoader:false,
                ClassLoad:false
            },
            Emit:this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Pedidos',
                BtnNewShow:false,
                ShowTitleFirst:false,
                ShowLoader:false,
                ShowFooter:false
            },
            Filtro:{
                Nombre:'',
                Pagina:1,
                Entrada:25,
                TotalItem:0,
                Placeholder:'Buscar..'
            },
            segurity:{},
            StyleTh:Configs.stylesTable.StyleTh,
            StylePr:Configs.stylesTable.StylePr,
            StyleTd:Configs.stylesTable.StyleTd,
            BndMostrarBotones:true,
            Pedidos:[]
        }
    },
    methods:{
        Recuperar(){
            this.ConfigList.ShowLoader=true,
            this.$http.get('pedidoscliente',{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Entrada:this.Filtro.Entrada,
                    Pag:this.Filtro.Pagina,
                    IdCliente:this.pIdCliente
                }
            }).then((res)=>{
                res.data.data.data.forEach((element)=>{
                    element.ShowButton=true;
                    element.ShowButtonDelete=true;
                });
                this.Pedidos=res.data.data.data;
                this.FiltrarBoton();
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        FiltrarBoton(){
            if (this.pPedidosSeleccionados.length>0) {
                this.Pedidos.forEach((Element)=>{
                    let BndCambio=this.pPedidosSeleccionados.some((El)=>{return El.IdPedido==Element.IdPedido});
                    if (BndCambio) {
                        Element.ShowButton=false;
                    }
                });
            }
            this.BndMostrarBotones=true;
        },
        SeleccionarPedido(item){
            item.ShowButton=false;
            this.bus.$emit('SeleccionarPedido',item);
        }

    },
    created(){
        this.poBtnSave.Toast=0;
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>{
            this.poBtnSave.DisableBtn=false;
            this.Recuperar();
        })
    }
}
</script>